import { Component, OnInit, ViewChild, Inject, OnDestroy } from '@angular/core';
import { SelectedItemsVisualizerOverlayRef } from './selected-items-visualizer-overlay-ref';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ItemNode } from '../models/item';
import { SelectedItemsVisualizerComponent } from '../selected-items-visualizer/selected-items-visualizer.component';
import { ItemListInjectionToken } from './item-list-injection-token';
import { DIALOG_REF_TOKEN, SELECTED_ITEMS_STREAM, ITEM_LIST } from './selected-items-overlay.token';

@Component({
    selector: 'se-selected-items-visualizer-overlay',
    templateUrl: './selected-items-visualizer-overlay.component.html',
    styleUrls: ['./selected-items-visualizer-overlay.component.scss'],
    standalone: false
})
export class SelectedItemsVisualizerOverlayComponent implements OnDestroy, OnInit {
  @ViewChild(SelectedItemsVisualizerComponent, { static: true }) private selectedItemsVisualizerComponent: SelectedItemsVisualizerComponent;
  private selectedItemSubscription: Subscription;

  constructor(
    @Inject(DIALOG_REF_TOKEN) public dialogRef: SelectedItemsVisualizerOverlayRef,
    @Inject(SELECTED_ITEMS_STREAM) public selectedItemsObservable: Observable<ItemNode[]>,
    @Inject(ITEM_LIST) private itemListInjectionToken: ItemListInjectionToken
  ) {
  }

  ngOnDestroy() {
    this.selectedItemSubscription.unsubscribe();
  }

  ngOnInit() {
    this.selectedItemsVisualizerComponent.initItemList(this.itemListInjectionToken.itemList);
    this.selectedItemSubscription = this.selectedItemsObservable.pipe(distinctUntilChanged()).subscribe((selectedItems: ItemNode[]) => {
      if (selectedItems && this.selectedItemsVisualizerComponent) {
        this.selectedItemsVisualizerComponent.updateValue(selectedItems);
      }
    });
  }
}
